import { render } from "./HolidaysUpdate.vue?vue&type=template&id=7bb8601c"
import script from "./HolidaysUpdate.vue?vue&type=script&lang=js"
export * from "./HolidaysUpdate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__